import { Table, Col } from "antd";
import { usePrint } from "../../extensions/print-context";
import { useEffect } from "react";
import "./print-page.css";

const PrintPage = () => {
  const { payload } = usePrint();

  useEffect(() => {
    if (payload?.autoPrint) {
      setTimeout(() => {
        window.print();
        // можно даже закрыть вкладку если нужно:
        // window.close();
      }, 300);
    }
  }, [payload]);

  if (!payload) return <div>Нет данных для печати</div>;

  const { data, columns, title } = payload;

  return (
    <div className="print-area">
      <h1>{title}</h1>
      <Table
        className="table-main"
        dataSource={data}
        columns={columns}
        size="small"
        pagination={false}
        rowKey="id"
        summary={(pageData) => {
          const totalDebet = pageData.reduce(
            (t, { id, dolg, vid }) =>
              id === 0 ? t : t + (Number(dolg) || 0) * (Math.sign(vid) || 1),
            0
          );
          const totalDepos = pageData.reduce(
            (t, { id, depos }) => id === 0 ? t : t + (Number(depos) || 0),
            0
          );

          return (
            <Table.Summary>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={4}>
                  <b>Итого: {pageData.length}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} colSpan={5}></Table.Summary.Cell>
                <Table.Summary.Cell index={2} colSpan={1}>
                  <Col style={{ textAlign: "right" }}>
                    <b>{Number(totalDepos.toFixed(2))}</b>
                  </Col>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} colSpan={1}>
                  <Col style={{ textAlign: "right" }}>
                    <b>{Number(totalDebet.toFixed(2))}</b>
                  </Col>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
    </div>
  );
};

export default PrintPage;
